import { DownloadOutlined } from "@ant-design/icons";
import { Button, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useNotification } from "../../hooks/useNotification.js";
import { MessageAPIService, UserApiService } from "../../services/api/index.js";
import Log from "../../shared/logger.js";

const MessageDownloader = ({ phone = null, loading = false, page }) => {
  const { notifyError, notifySuccess, notifyInfo, closeNotify } =
    useNotification();

  const [isFetching, setIsFetching] = useState(loading);

  const downloadTxtFile = async () => {
    if (!phone) {
      notifyError("No phone number provided");
      return;
    }

    setIsFetching(true);
    try {
      const response = await UserApiService.userConversation(phone, 1, 999);
      const fetchedMessages = response.messages || [];

      if (fetchedMessages.length === 0) {
        notifyError("No messages to download");
        return;
      }

      const text = fetchedMessages
        .map(
          (msg) =>
            `${new Date(
              msg.received_at
            ).toISOString()} - [${msg.source.toUpperCase()}]: ${msg.body}`
        )
        .join("\n");

      const blob = new Blob([text], { type: "text/plain" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "messages.txt";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      notifySuccess("Messages downloaded");
    } catch (error) {
      Log.e("Error fetching messages:", error);
      notifyError("Failed to download messages");
    } finally {
      setIsFetching(false);
    }
  };

  const downloadAllConversations = async () => {
    notifyInfo("Downloading conversations...", { persist: true });

    try {
      const res = await MessageAPIService.downloadAnalyzedConversation();

      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "user_conversations.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      notifySuccess("Downloaded all conversations.");
    } catch (err) {
      Log.e("Failed to download:", err);
      notifyError("Error downloading conversations");
    } finally {
      setTimeout(() => closeNotify(), 5000);
    }
  };

  return (
    <Tooltip title={"Click to download in .txt"}>
      {/* <Button onClick={downloadAllConversations}>
        Download Conversations Analysis
      </Button> */}

      {page === "admin" ? (
        <Button
          variant="contained"
          sx={{
            bgcolor: "#005CFF",
            color: "white",
            textTransform: "none",
            m: 1,
          }}
          onClick={downloadTxtFile}
        >
          Download Conversation
        </Button>
      ) : (
        <IconButton
          sx={{
            mr: 1,
            color: "white",
            bgcolor: "#005CFF",
            textTransform: "none",
            ":hover": { bgcolor: "#005CFF" },
          }}
          variant="contained"
          disabled={!phone}
          loading={String(isFetching).toString()}
          onClick={downloadTxtFile}
        >
          <DownloadOutlined />
        </IconButton>
      )}
    </Tooltip>
  );
};

export default MessageDownloader;
